import { TypographyProps } from "@mui/material/Typography";
import React from "react";
import { MuiTypography } from "../typography/MuiTypography";

interface HtmlTypographyProps {
  html: string;
  variant?: TypographyProps["variant"];
  onClick?: () => void;
  className?: string;
}

const HtmlTypography: React.FC<HtmlTypographyProps> = ({
  html,
  variant,
  onClick,
  className,
}) => {
  return (
    <MuiTypography
      variant={variant}
      dangerouslySetInnerHTML={{ __html: html }}
      onClick={onClick}
      className={className}
    />
  );
};

export default HtmlTypography;
